export default "__VITE_ASSET__DvKAXbJz__"